@layer module {
.page-shell {
            grid-area: main-content;
            display: flex;
            flex-flow: column nowrap;
    }

.page-header {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
    }

.page-actions {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
    }

.page-shell-centered {
            align-items: center;
    }

.page-fill-frame {
            display: contents;
    }

.page-fill-track,
.page-fill-track-x {
            display: none;
    }

.page-fill-item {
            flex: 1 0 auto;
    }

.page-fill-card {
            display: flex;
            flex: 1 0 auto;
            flex-direction: column;
    }

      @media (max-width: 539px) {
                .page-actions {
                        flex-basis: 100%;
                    }
          }

      @media (min-width: 1175px) {

                .page-fill-item {
                        flex: 1 1 0;
                    }

                .page-fill-card {
                        display: flex;
                        flex: 1 1 0;
                        flex-direction: column;
                        overflow: hidden;
                    }

                .page-fill-frame {
                        position: relative;
                        display: block;
                        flex: 1 1 auto;
                    }

                .page-fill-scroll {
                        position: absolute;
                        overflow: auto;
                        scrollbar-width: none;
                    }

                .page-fill-scroll::-webkit-scrollbar {
                        display: none;
                    }

                .page-fill-track {
                        position: absolute;
                        display: block;
                    }

                .page-fill-track-x {
                        position: absolute;
                        display: flex;
                        align-items: flex-end;
                    }

                .page-fill-track,
                .page-fill-track-x {
                        pointer-events: none;
                    }

                .page-fill-track--active {
                        pointer-events: auto;
                    }

                .page-fill-thumb,
                .page-fill-thumb-x {
                        cursor: grab;
                        touch-action: none;
                    }

                .page-fill-thumb-x {
                        flex: none;
                    }


                .page-fill-scroll :global(.mm-table-view-head-cell) {
                        position: sticky;
                        z-index: 1;
                    }

                .page-fill-rows {
                        container-type: size;
                    }

          }
} // layer module










@layer app {
.page-shell {
            padding: $size-20 0 $size-30;
    }

.page-header {
            gap: $size-12 $size-16;
            margin-bottom: $size-16;
    }

.page-subtitle {
            margin: $size-4 0 0;
    }

.page-actions {
            gap: $size-8;
            margin-left: auto;
    }

.page-surface {
            border-radius: $size-8;
    }

.page-shell-fill {
            min-height: calc(100vh - $size-64);
            min-height: calc(100dvh - $size-64);
    }

.page-fill-card {
            min-height: $size-300;
    }

      @media (max-width: 539px) {
                .page-actions {
                        margin-left: 0;
                    }
          }

      @media (min-width: 1175px) {
                .page-shell-fill {
                        height: calc(100vh - $size-64);
                    }
                .page-fill-item {
                        min-height: 0;
                    }
                .page-fill-card {
                        min-height: $size-300;
                    }
                .page-fill-frame {
                        min-height: 0;
                    }
                .page-fill-scroll {
                        inset: 0;
                    }
                .page-fill-track {
                        top: $size-42;
                        right: $size-6;
                        bottom: $size-8;
                        width: $size-10;
                    }
                .page-fill-track-x {
                        right: $size-20;
                        bottom: $size-6;
                        left: $size-6;
                        height: $size-10;
                    }
                .page-fill-thumb {
                        width: $size-4;
                        margin-left: auto;
                        border-radius: $size-4;
                    }
                .page-fill-thumb-x {
                        height: $size-4;
                        border-radius: $size-4;
                    }
                :where(.page-fill-track):hover .page-fill-thumb {
                        width: $size-8;
                    }
                :where(.page-fill-track-x):hover .page-fill-thumb-x {
                        height: $size-8;
                    }
                .page-fill-scroll :global(.mm-table-view-head-cell) {
                        top: 0;
                    }
                .page-fill-rows tbody tr:not(:global(.page-fill-natural-row)) {
                        height: min(calc((100cqh - $size-42) / 10), $size-88);
                    }
          }

.page-title {
            margin: 0;
            color: var(--text-primary);
            font-size: var(--font-size-3xl);
            font-style: normal;
            line-height: 1.2;
            font-weight: 500;
            letter-spacing: $size-neg-0-5;
    }

.page-subtitle {
            color: var(--text-body);
            font-size: var(--font-size-base);
    }

.page-title-responsive {
            line-height: normal;
            font-weight: 500;
    }

      @media (min-width: 540px) {
                .page-title-responsive {
                        font-size: var(--font-size-3xl);
                    }
          }

.page-surface {
            background-color: var(--page-surface-background);
            box-shadow: var(--shadow-page-panel);
    }

.page-fill-track,
.page-fill-track-x {
            opacity: 0;
            transition: opacity 0.25s ease;
    }

:where(.page-fill-frame):hover .page-fill-track,
:where(.page-fill-frame):hover .page-fill-track-x,
.page-fill-track--awake {
            opacity: 1;
    }

.page-fill-thumb,
.page-fill-thumb-x {
            background: var(--scrollbar-thumb-bg);
            transition: width 0.15s ease, height 0.15s ease, background-color 0.15s ease;
    }

.page-fill-thumb:hover,
.page-fill-thumb-x:hover {
            background: var(--text-secondary);
    }

      @media (prefers-reduced-motion: reduce) {
                .page-fill-track,
                .page-fill-track-x,
                .page-fill-thumb,
                .page-fill-thumb-x {
                        transition: none;
                    }
          }
} // layer app










@layer context {
:global(.support-wrapper).page-shell {
            padding-top: $size-10;
            padding-bottom: $size-15;
    }

.page-title:global(.flow-panel-title),
.page-title:global(.send-money-title) {
            margin-bottom: $size-20;
    }

.page-title:global(.flow-panel-title),
.page-title:global(.send-money-title) {
            text-align: center;
    }

      @media (min-width: 540px) {
                .page-title:global(.flow-panel-title),
                .page-title:global(.send-money-title) {
                        margin-bottom: $size-30;
                    }
          }

      @media (min-width: 1175px) {
                :global(.support-wrapper).page-shell {
                        padding-top: $size-15;
                        padding-bottom: $size-30;
                    }
          }

      @media (min-width: 1281px) {
                :global(.support-wrapper).page-shell {
                        height: calc(100vh - $size-64);
                        overflow: hidden;
                    }
          }

      @media (min-width: 540px) {
                :global(.requests-title) {
                        margin-bottom: $size-30;
                    }
          }

:global(.requests-title) {
            margin-bottom: 0;
            text-align: left;
    }
} // layer context
